import interact from 'interactjs'

import initDragDrop from './dragDrop.js'
import { generateGrid, generateEmptyGrid, resolveGrid, checkNeighbourIndex, getAvailableIndexes } from './grid.js'
import { getRandomInt } from './tools.js'

import Dot from '../entities/Dot.js'
import Duo from '../entities/Duo.js'

const dimension = 4
const size = dimension * dimension
const grid = generateGrid(dimension)
let tetrisGrid = []
let pieceList = []

function putPiece (grid, piece) {
  const availableIndexes = getAvailableIndexes(grid)
  let position = null

  if (piece.size === 2) {
    let tries = 0
    let testingPositions = availableIndexes

    while (tries < availableIndexes.length) {
      position = testingPositions[getRandomInt(testingPositions.length)]
      testingPositions = testingPositions.filter(item => String(item) !== String(position))

      const neighbour = checkNeighbourIndex(grid, position[0], position[1])
      if (neighbour) {
        // positionnement de la pièce dans la grille
        grid[position[0]][position[1]] = piece
        grid[neighbour[0]][neighbour[1]] = piece
        break
      } else {
        ++tries
      }
    }
  } else {
    position = availableIndexes[getRandomInt(availableIndexes.length)]
    grid[position[0]][position[1]] = piece
    return true
  }
}

function fillGrid (grid, pieceList) {
  for (let i = 0; i < pieceList.length; i++) {
    putPiece(grid, pieceList[i])
  }
}

function getInformation (e) {
  e.stopPropagation()
  const exitmodal = document.querySelector('.exitModal')
  const modal = document.querySelector('.modal')

  let element = null
  switch (e.target.style.backgroundColor) {
    case 'rgb(160, 218, 222)':
      element = 'Eau'
      modal.style.color = 'white'
      break
    case 'rgb(75, 186, 112)':
      element = 'Air'
      modal.style.color = 'white'
      break
    case 'rgb(202, 97, 98)':
      element = 'Terre'
      modal.style.color = 'white'
      break
    case 'rgb(201, 43, 43)':
      element = 'Feu'
      modal.style.color = 'white'
      break
    case 'azure':
      element = 'Glace = Eau + Air'
      modal.style.color = '#263238'
      break
    case 'chocolate':
      element = 'Boue = Eau + Terre'
      modal.style.color = 'white'
      break
    case 'mediumorchid':
      element = 'Vapeur = Eau + Feu'
      modal.style.color = 'white'
      break
    case 'wheat':
      element = 'Sable = Air + Terre'
      modal.style.color = '#263238'
      break
    case 'gold':
      element = 'Orage = Air + Feu'
      modal.style.color = '#263238'
      break
    case 'gray':
      element = 'Roche = Terre + Feu'
      modal.style.color = 'white'
      break
  }

  modal.style.backgroundColor = e.target.style.backgroundColor
  modal.textContent = element
  exitmodal.style.display = 'flex'
}

export default function init () {
  initDragDrop()
  const nbDot = 2
  const nbDuo = (size - nbDot) / 2

  let isResolvable = false

  while (!isResolvable) {
    pieceList = []

    for (let i = 0; i < nbDuo; i++) {
      pieceList.push(new Duo())
    }
    for (let j = 0; j < nbDot; j++) {
      pieceList.push(new Dot())
    }

    // rempli une grille avec les pièce de tetris
    tetrisGrid = generateEmptyGrid(dimension)
    let flattenTetrisGrid = tetrisGrid.flat()

    while (flattenTetrisGrid.includes('x')) {
      fillGrid(tetrisGrid, pieceList)
      flattenTetrisGrid = tetrisGrid.flat()
      if (!flattenTetrisGrid.includes('x')) {
        break
      } else {
        tetrisGrid = generateEmptyGrid(dimension)
      }
    }

    // ajoute un type de pièce à chaque pièce de tetris
    for (let i = 0; i < grid.length; i++) {
      const row = grid[i]
      for (let j = 0; j < row.length; j++) {
        tetrisGrid[i][j].addType(row[j])
      }
    }
    isResolvable = resolveGrid(dimension, grid, tetrisGrid)
  }

  const empties = document.querySelectorAll('.empty')
  const modal = document.querySelector('.exitModal')

  modal.addEventListener('click', e => {
    if (!e.target.classList.contains('modal')) e.target.style.display = 'none'
  })

  // change la couleur de chaque pièce de tetris en fonction de leur type
  // retire les bordure des cases pour lier les bouts de pièces entre elles
  const flattenTetrisGrid = tetrisGrid.flat()
  for (let i = 0; i < flattenTetrisGrid.length; i++) {
    const piece = flattenTetrisGrid[i]
    empties[i].style.backgroundColor = piece.color
    empties[i].addEventListener('click', e => {
      if (e.target.classList.contains('empty')) getInformation(e)
    })
    if (piece.size > 1) {
      if (piece.firstInPosition) {
        if (piece.id === flattenTetrisGrid[i - 1].id) {
          empties[i].style.borderLeft = 0
          empties[i - 1].style.borderRight = 0
        } else {
          empties[i].style.borderTop = 0
          empties[i - 4].style.borderBottom = 0
        }
      }
      piece.firstInPosition = true
    }
  }

  const elementTypes = {
    eau: 1,
    air: 2,
    terre: 3,
    feu: 4
  }

  interact('.empty')
    .dropzone({
      ondrop: function (event) {
        if (event.target.childNodes.length === 0) {
          event.target.append(event.relatedTarget)
        }
        event.relatedTarget.style.transform = 'translate(0px, 0px)'
        const isFull = !Array.from(empties).map(empty => empty.childNodes.length).includes(0)
        if (isFull) {
          const flattenGrid = grid.flat()
          const result = Array.from(empties).map(empty => {
            const emptySearch = flattenTetrisGrid[empty.id.split('-')[1] - 1]
            const gridSearch = flattenGrid[empty.id.split('-')[1] - 1]
            const elementType = empty.childNodes[0].id.split('-')[0]
            if (emptySearch.type1 === elementTypes[elementType] || emptySearch.type2 === elementTypes[elementType]) {
              if (elementTypes[elementType] === gridSearch) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          })
          document.querySelector('.elements').style.display = 'none'
          if (!result.includes(false)) {
            document.querySelector('.resultGame').textContent = 'Victoire, cliquer pour recommencer'
            document.querySelector('.resultGame').style.color = 'mediumseagreen'
          } else {
            document.querySelector('.resultGame').textContent = 'Défaite, cliquer pour recommencer'
            document.querySelector('.resultGame').style.color = 'red'
          }
          document.querySelector('.resultGame').style.display = 'block'
          document.querySelector('.resultGame').addEventListener('click', () => {
            document.location.reload()
          })
        }
      }
    })
}
